import React, { useCallback } from 'react';
import { getIn } from 'formik';

import { Radio } from '../../radio';
import { FieldElementPropTypes } from '../propTypes';

const RadioField = ({
  field: { id, name, mode, options, value, ...props },
  ctx: { setFieldValue, touched, errors, setFieldTouched, classes, submitCount }
}) => {
  const onChange = useCallback(
    (e) => {
      setFieldValue(name || id, e.target.value);
      setFieldTouched(id, true, false);
    },
    [setFieldTouched, setFieldValue, id, name]
  );

  return (
    <Radio
      key={id}
      id={id}
      name={name || id}
      value={value || ''}
      mode={mode}
      options={options}
      classes={classes[id]}
      onChange={onChange}
      error={submitCount > 0 && getIn(touched, name || id) && !!getIn(errors, name || id)}
      helperText={getIn(touched, name || id) ? getIn(errors, name || id) : undefined}
      {...props}
    />
  );
};

RadioField.propTypes = FieldElementPropTypes;

export default RadioField;
